import { getAllEligiblePromotions } from 'pricing-pages-lib/utils/promotionUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { FetchPromotionsRequestTypes } from '../actions/PromotionActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
import { transformState } from './SelectorUtils';
export const fetchPromotionsStatus = makeRequestStatusSelector(FetchPromotionsRequestTypes.REQUEST);

// returns an array of all promotions keys with a discount that can be applied
export const allEligibleDiscountsSelector = createSelectorFromUtil(getAllEligiblePromotions, transformState);